<template>
  <div v-if="isClient == true">
    <div v-if="loadingOverlay === true">
      <div class="lds-dual-ring"></div>
    </div>

    <div v-else-if="insightsLoaded == true">
      <div class="row">
        <div class="col-md-12">
          <chart-card
            :chart-data="insightChart.data"
            :chart-height="75"
            :chart-options="insightChart.options"
          >
            <template slot="header">
              <h5 class="card-title">Reached {{ reachTotal }} People</h5>
              <p class="card-category">Instagram Profile Performance</p>
              <div style="right: 15px; top: 10px; position: absolute">
                <div class="legend" style="float: left">
                  <i class="fa fa-circle" style="color: #f17e5d"></i>
                  Impressions
                </div>
                <div class="legend" style="float: left; margin-left: 20px">
                  <i class="fa fa-circle" style="color: #6bd098"></i> Reach
                </div>
              </div>
            </template>

            <!-- <template slot="footer">
          <hr />
          <div class="stats">
            <i class="fa fa-history"></i> Updated 3 minutes ago
          </div>
            </template>-->
          </chart-card>
        </div>
      </div>
      <div class="row" v-if="profileVisitsChartLoaded == true">
        <div class="col-md-6">
          <card>
            <template slot="header">
              <h4 class="card-title">
                {{ profileVisitsTotal }} Profile Visits
              </h4>
              <p class="category"></p>
            </template>
            <line-chart
              :labels="profileVisitsChart.labels"
              :height="75"
              :datasets="profileVisitsChart.datasets"
              :extra-options="profileVisitsChart.options"
            ></line-chart>
          </card>
        </div>
        <div class="col-md-6" v-if="websiteClicksChartLoaded == true">
          <card>
            <template slot="header">
              <h4 class="card-title">
                {{ websiteClicksTotal }} Website Clicks
              </h4>
              <p class="category"></p>
            </template>
            <line-chart
              :labels="websiteClicksChart.labels"
              :height="75"
              :datasets="websiteClicksChart.datasets"
              :extra-options="websiteClicksChart.options"
            ></line-chart>
          </card>
        </div>
      </div>
      <div class="row" v-if="postList.length > 0">
        <div class="col-md-12">
          <div class="card">
            <div
              class="card-header"
              style="padding-bottom: 0px; margin-bottom: 0px"
            >
              <div>
                <h5
                  class="title"
                  style="padding-bottom: 0px; margin-bottom: 0px"
                >
                  Recent Posts
                </h5>
                <hr />
              </div>

              <div style="top: 0px; right: 10px; position: absolute">
                <p-button
                  style="margin-top: 15px"
                  type="info"
                  @click="
                    $router.push(
                      `/instagram/content/${clientDetails.instagramProfile}`
                    )
                  "
                  link
                  >view all</p-button
                >
              </div>
            </div>

            <div class="card-body">
              <div
                class="post-preview"
                v-for="post in postList"
                :key="post.shortcode"
              >
                <span v-if="post.cached == true">
                  <img
                    :src="post.imageUrlCache"
                    class="img-row"
                    alt
                    @click="$router.push(`/instagram/post/${post.shortcode}`)"
                  />
                </span>
                <span v-else>
                  <img
                    :src="post.imageUrl"
                    class="img-row"
                    alt
                    @click="$router.push(`/instagram/post/${post.shortcode}`)"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="mentionsLoaded == true">
        <div class="col-md-12">
          <div class="card">
            <div
              class="card-header"
              style="padding-bottom: 0px; margin-bottom: 0px"
            >
              <div>
                <h5
                  class="title"
                  style="padding-bottom: 0px; margin-bottom: 0px"
                >
                  Recent Tags
                </h5>
                <hr />
              </div>

              <div style="top: 0px; right: 10px; position: absolute">
                <p-button
                  style="margin-top: 15px"
                  type="info"
                  @click="
                    $router.push(
                      `/instagram/content/${
                        clientDetails.instagramProfile
                      }/?view=mentions`
                    )
                  "
                  link
                  >view all</p-button
                >
              </div>
            </div>
            <div class="card-body">
              <div
                class="post-preview"
                v-for="post in mentionPostList"
                :key="post.shortcode"
              >
                <span v-if="post.cached == true">
                  <img
                    :src="post.imageUrlCache"
                    class="img-row"
                    alt
                    @click="$router.push(`/instagram/post/${post.shortcode}`)"
                  />
                </span>
                <span v-else>
                  <img
                    :src="post.imageUrl"
                    class="img-row"
                    alt
                    @click="$router.push(`/instagram/post/${post.shortcode}`)"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <card>
        <div class="row">
          <div class="col-12">
            No company Instagram profile connected yet. Please
            <a href="/account/active-instagram">connect profile</a>.
          </div>
        </div>
      </card>
    </div>

    <div v-if="shopList !== null">
      <card>
        <div v-if="shopList.length > 0">
          <el-table :data="shopList" v-if="shopList.length > 0">
            <el-table-column label="Store" width="400">
              <template slot-scope="props">{{ props.row.shop }}</template>
            </el-table-column>
            <el-table-column label="Actions">
              <template slot-scope="props">
                <p-button
                  round
                  outline
                  type="info"
                  size="sm"
                  @click="$router.push('/shopify/orders/' + props.row.shop)"
                  >view analytics</p-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>
          <div class="row">
            <div class="col-12">
              No Shopify store connected yet. Please
              <a :href="'/account/active-shopify/' + this.clientDetails._id"
                >connect store</a
              >.
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import axios from "axios";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import timeVars from "@/config/timeVars";
import ChartCard from "@/components/UIComponents/Cards/ChartCard";
import LineChart from "@/components/UIComponents/Charts/LineChart";
import BarChart from "@/components/UIComponents/Charts/BarChart";
import PieChart from "@/components/UIComponents/Charts/PieChart";

import {
  fbGraphInstagramInsights,
  clientProfileReadApi,
  userLoadApi,
  fbGraphMentionPosts,
  instagramPostApi,
  fbGraphInstagramCheck,
  clientStoreListApi,
} from "@/config/appSettings";
import Card from "../UIComponents/Cards/Card.vue";
const tooltipOptions = {
  tooltipFillColor: "rgba(0,0,0,0.5)",
  tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  tooltipFontSize: 14,
  tooltipFontStyle: "normal",
  tooltipFontColor: "#fff",
  tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  tooltipTitleFontSize: 14,
  tooltipTitleFontStyle: "bold",
  tooltipTitleFontColor: "#fff",
  tooltipYPadding: 6,
  tooltipXPadding: 6,
  tooltipCaretSize: 8,
  tooltipCornerRadius: 6,
  tooltipXOffset: 10,
};

export default {
  name: "Dashboard",
  data: () => ({
    alertMsg: "",
    alertType: "",
    displayAlert: false,
    isTeam: null,
    isClient: null,
    isInfluencer: null,
    clientDetails: null,
    auth: null,
    getTime: null,
    insightChart: {},
    insightsLoaded: false,
    profileVisitsChart: {},
    profileVisitsChartLoaded: false,
    websiteClicksChart: {},
    websiteClicksChartLoaded: false,
    websiteClicksTotal: 0,
    profileVisitsTotal: 0,
    impressionsTotal: 0,
    reachTotal: 0,
    mentionsLoaded: false,
    mentionPostList: [],
    postList: [],
    loadingOverlay: false,
    loadingOverlayText: null,
    instagramLinked: false,
    shopList: null,
  }),
  components: {
    ChartCard,
    LineChart,
    BarChart,
    PieChart,
    Card,
  },
  created: function() {
    let msgData = this.$route.query;
    //console.log("HERE IS THE CONFIRM DATA: ", confirmData);
    this.alertMsg = msgData.msg;
    this.alertType = msgData.msg_type;
    if (msgData.msg_show === true) {
      this.displayAlert = true;
    }
  },
  computed: mapGetters(["profileStore", "relatedProfileStore"]),
  methods: {
    async checkNoAuthProfiles() {
      try {
        //console.log("CHECKING RELATED PROFILES: ", this.relatedProfiles);
        if (
          this.relatedProfileStore !== null &&
          typeof this.relatedProfileStore !== "undefined"
        ) {
          this.relatedProfiles = this.relatedProfileStore;
        }
        if (this.relatedProfiles !== null) {
          //console.log("RESETTING PROFILES:", this.relatedProfiles);
          this.relatedProfileList = this.relatedProfiles.map((x) => {
            return x.instagramProfile;
          });
          let instagramProfileString = this.relatedProfileList.join(",");
          /*console.log(
            "LINK:",
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${instagramProfileString}`
          );*/
          let noAuthProfileCheckResponse = await axios.get(
            `${fbGraphInstagramCheck}/?usertoken=${
              this.auth
            }&profiles=${instagramProfileString}`
          );
          /*console.log(
            "RELATED PROFILE AUTH CHECK:",
            noAuthProfileCheckResponse.data
          );*/
          if (noAuthProfileCheckResponse.data.exists === false) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.noAuthProfiles = this.relatedProfiles;
            this.instagramLinked = false;
          }
          if (noAuthProfileCheckResponse.data.exists == true) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.instagramLinked = true;
          }
        } else {
          //console.log("RELATED PROFILES NOT FOUND");
          if (this.isTeam !== true) {
            if (this.relatedProfileStore == null) {
              let relatedProfileResponse = await axios.get(
                `${userRelatedProfilesApi}/?usertoken=${this.auth}`
              );
              this.relatedProfiles = relatedProfileResponse.data.result;
              store.dispatch(
                "storeRelatedProfiles",
                relatedProfileResponse.data.result
              );
            } else {
              this.relatedProfiles = this.relatedProfileStore;
            }
            //console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
          }
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadProfileAnalytics() {
      try {
        let endDate = this.getTime.startOfDay;
        let startDate =
          moment
            .unix(endDate)
            .utc()
            .subtract(7, "days") / 1000;

        //console.log("START DATE:", startDate);

        let insightLookupUrl = `${fbGraphInstagramInsights}/?instagram=${
          this.clientDetails.instagramProfile
        }&usertoken=${this.auth}&start=${startDate}&end=${endDate}`;
        //console.log("INSIGHT URL: ", insightLookupUrl);
        let instagramInsightResponse = await axios.get(insightLookupUrl);
        if (instagramInsightResponse.data.success == true) {
          this.loadingOverlay = false;
          let reachData = instagramInsightResponse.data.result.insightData.filter(
            (x) => {
              return x.type == "reach";
            }
          );
          this.reachTotal = reachData[0].total;

          //console.log("REACH DATA: ", reachData);
          let impressionData = instagramInsightResponse.data.result.insightData.filter(
            (x) => {
              return x.type == "impressions";
            }
          );
          //console.log("IMPRESSION DATA: ", impressionData);
          this.impressionsTotal = impressionData[0].total;
          let websiteClickData = instagramInsightResponse.data.result.insightData.filter(
            (x) => {
              return x.type == "website_clicks";
            }
          );
          this.websiteClicksTotal = websiteClickData[0].total;

          //          console.log("WEBSITE CLICK DATA: ", websiteClickData);

          let profileVisitsData = instagramInsightResponse.data.result.insightData.filter(
            (x) => {
              return x.type == "profile_views";
            }
          );
          this.profileVisitsTotal = profileVisitsData[0].total;

          //        console.log("WEBSITE CLICK DATA: ", profileVisitsData);

          this.insightChart = {
            data: {
              labels: instagramInsightResponse.data.result.timeLabel,
              datasets: [
                {
                  label: "Reach",
                  borderColor: "#6bd098",
                  backgroundColor: "#6bd098",
                  pointRadius: 2,
                  pointHoverRadius: 2,
                  borderWidth: 3,
                  data: reachData[0].data,
                },
                {
                  label: "Impressions",
                  borderColor: "#f17e5d",
                  backgroundColor: "#f17e5d",
                  pointRadius: 2,
                  pointHoverRadius: 2,
                  borderWidth: 3,
                  data: impressionData[0].data,
                },
                /*{
                  borderColor: "#fcc468",
                  backgroundColor: "#fcc468",
                  pointRadius: 0,
                  pointHoverRadius: 0,
                  borderWidth: 3,
                  data: [370, 394, 415, 409, 425, 445, 460, 450, 478, 484]
                }*/
              ],
            },
            options: {
              tooltips: tooltipOptions,
              scales: {
                yAxes: [
                  {
                    ticks: {
                      fontColor: "#9f9f9f",
                      beginAtZero: false,
                      maxTicksLimit: 5,
                      //padding: 20
                    },
                    gridLines: {
                      drawBorder: false,
                      zeroLineColor: "transparent",
                      color: "rgba(255,255,255,0.05)",
                    },
                  },
                ],

                xAxes: [
                  {
                    barPercentage: 1.6,
                    gridLines: {
                      drawBorder: false,
                      color: "rgba(255,255,255,0.1)",
                      zeroLineColor: "transparent",
                      display: false,
                    },
                    ticks: {
                      padding: 20,
                      fontColor: "#9f9f9f",
                    },
                  },
                ],
              },
            },
          };
          this.insightsLoaded = true;
          this.websiteClicksChart = {
            labels: instagramInsightResponse.data.result.timeLabel,
            datasets: [
              {
                label: "Website Clicks",
                borderColor: "#f17e5d",
                pointBackgroundColor: "#f17e5d",
                pointRadius: 3,
                pointHoverRadius: 3,
                lineTension: 0,
                fill: false,
                borderWidth: 3,
                data: websiteClickData[0].data,
              },
            ],
            color: "#f17e5d",
            options: {
              tooltips: tooltipOptions,
              scales: {
                yAxes: [
                  {
                    ticks: {
                      fontColor: "#9f9f9f",
                      beginAtZero: false,
                      maxTicksLimit: 3,
                      minTicksLimit: 1,
                    },
                    gridLines: {
                      lineWidth: 1,
                      zeroLineColor: "transparent",
                      color: "#FAFAFA",
                      /*display: false
                      /*drawBorder: false,
                      borderDash: [8, 5],
                      "*/
                    },
                  },
                ],

                xAxes: [
                  {
                    barPercentage: 1.6,
                    gridLines: {
                      display: false,

                      /*drawBorder: false,
                      borderDash: [8, 5],
                      color: "#9f9f9f",
                      zeroLineColor: "transparent"*/
                    },
                    ticks: {
                      padding: 20,
                      fontColor: "#9f9f9f",
                    },
                  },
                ],
              },
            },
          };
          //     console.log("WEBSITE CLICKS CHART DATA: ", this.websiteClicksChart);
          this.websiteClicksChartLoaded = true;
          this.profileVisitsChart = {
            labels: instagramInsightResponse.data.result.timeLabel,
            datasets: [
              {
                label: "Profile Visits",
                borderColor: "#f17e5d",
                pointBackgroundColor: "#f17e5d",
                pointRadius: 3,
                pointHoverRadius: 3,
                lineTension: 0,
                fill: false,
                borderWidth: 3,
                data: profileVisitsData[0].data,
              },
            ],
            color: "#f17e5d",
            options: {
              tooltips: tooltipOptions,
              scales: {
                yAxes: [
                  {
                    ticks: {
                      fontColor: "#9f9f9f",
                      beginAtZero: false,
                      maxTicksLimit: 3,
                      minTicksLimit: 1,
                    },
                    gridLines: {
                      lineWidth: 1,
                      zeroLineColor: "transparent",
                      color: "#FAFAFA",
                      /*display: false
                      /*drawBorder: false,
                      borderDash: [8, 5],
                      "*/
                    },
                  },
                ],

                xAxes: [
                  {
                    barPercentage: 1.6,
                    gridLines: {
                      display: false,

                      /*drawBorder: false,
                      borderDash: [8, 5],
                      color: "#9f9f9f",
                      zeroLineColor: "transparent"*/
                    },
                    ticks: {
                      padding: 20,
                      fontColor: "#9f9f9f",
                    },
                  },
                ],
              },
            },
          };
          this.profileVisitsChartLoaded = true;
        }
        //console.log("INSTAGRAM RESPONSE:", instagramInsightResponse.data);
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadRecentPosts() {
      try {
        let instagramPostResponse = await axios.get(
          `${instagramPostApi}/?usertoken=${this.auth}&instagram=${
            this.clientDetails.instagramProfile
          }`
        );

        //console.log("POST LIST :", instagramPostResponse.data);

        if (instagramPostResponse.data.success === true) {
          //console.log("SETTING POST LIST:");

          this.postList = instagramPostResponse.data.result.slice(0, 7);
          //this.filterList("feed");
          //console.log("POST LIST SET:", this.postList);
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadMentionPosts() {
      try {
        let mentionPostUrl = `${fbGraphMentionPosts}/?usertoken=${
          this.auth
        }&instagram=${this.clientDetails.instagramProfile}`;
        //console.log("HERE IS THE MENTION POST URL: ", mentionPostUrl);
        let mentionPostResponse = await axios.get(mentionPostUrl);
        //   console.log(mentionPostResponse.data);
        if (mentionPostResponse.data.success == true) {
          this.mentionPostList = mentionPostResponse.data.result.tags.slice(
            0,
            7
          );
          this.mentionsLoaded = true;
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadInfluencerPosts() {},
    async setProfileType() {
      //console.log("PROFILE STORE:", this.profileStore);
      if (this.profileStore.isTeam === true) {
        this.isTeam = true;
      }
      try {
        if (this.profileStore.profileTypes.length > 0) {
          if (this.profileStore.profileTypes.indexOf("influencer") !== -1) {
            this.isInfluencer = true;
          }
          if (this.profileStore.profileTypes.indexOf("client") !== -1) {
            this.isClient = true;
          }
        }
      } catch (err) {
        //console.log("ERROR:", err);
      }

      // IF NOT LOADED YET LOAD DIRECTLY TO SET PROFILE TYPE
      //console.log("PROFILE STORE MAIN:", this.profileStore);
      if (this.profileStore === false) {
        let profileData = await axios.get(`${userLoadApi}${this.auth}`);
        //console.log("PROFILE DATA MAIN:", profileData.data);
        if (profileData.data.success === true) {
          if (profileData.data.result.isTeam === true) {
            this.isTeam = true;
          }
          try {
            if (profileData.data.result.profileTypes.length > 0) {
              if (
                profileData.data.result.profileTypes.indexOf("influencer") !==
                -1
              ) {
                this.isInfluencer = true;
              }
              if (
                profileData.data.result.profileTypes.indexOf("client") !== -1
              ) {
                this.isClient = true;
              }
            }
          } catch (err) {
            //console.log("ERROR:", err);
          }
        }
      }
    },
    async businessProfileLoad() {
      try {
        let businessProfileResponse = await axios.get(
          `${clientProfileReadApi}/?usertoken=${this.auth}&client=${
            this.$route.params.clientId
          }`
        );
        //console.log("BUSINESS PROFILE", businessProfileResponse.data);
        if (businessProfileResponse.data.success == true) {
          this.clientDetails = businessProfileResponse.data.result[0];
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadClientShops() {
      try {
        let clientShopListUrl = `${clientStoreListApi}/?usertoken=${
          this.auth
        }&client=${this.clientDetails._id}`;

        let clientShopListResponse = await axios.get(clientShopListUrl);
        //console.log(" RESULT: ", clientShopListResponse.data);
        if (clientShopListResponse.data.success == true) {
          this.shopList = clientShopListResponse.data.result.filter((x) => {
            return x.status == "active";
          });
          return;
        }
        this.shopList = [];
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadPageContent() {
      await this.setProfileType();
      this.getTime = await timeVars.timeInfo();
      await this.businessProfileLoad();
      await this.checkNoAuthProfiles();
      this.loadClientShops();
      //console.log("LINKED INSTAGRAM:", this.instagramLinked);
      if (this.instagramLinked == true) {
        this.loadProfileAnalytics();
        this.loadMentionPosts();
        this.loadRecentPosts();
      }

      this.loadingOverlay = false;
    },
  },
  mounted() {
    this.loadingOverlay = true;
    this.loadingOverlayText = "Loading...";
    this.auth = firebase.auth().currentUser.uid;
    this.loadPageContent();
  },
};
</script>

<style scoped>
.center-align {
  text-align: center;
}
.post-preview {
  float: left;
  padding: 10px;
  height: 150px;
  width: 150px;
  overflow: hidden;
  cursor: pointer;
}

.img-row {
  object-fit: cover;
}
</style>
